import axios from "axios";
const jsonConfig = require("../../config.json");

const runalertResponse = async () => {
  try {
    const getAllResponse = await axios.post(jsonConfig.apiUrl + "RunAlert","", {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default runalertResponse;
